import React from 'react';
import { translate } from '@utils/i18n';
import WizardView from '@components/WizardView';
const namespace = 'features.settings.service_trade';
export default function SuccessStep({ onStartSync, onSkipSync, isLoading, error }) {
    const actions = [
        {
            label: translate('wizard.skip_sync', { namespace }),
            onClick: onSkipSync,
            variant: 'secondary',
            disabled: isLoading
        },
        {
            label: translate('wizard.start_sync', { namespace }),
            onClick: onStartSync,
            variant: 'primary',
            disabled: isLoading,
            isLoading
        }
    ];
    return (React.createElement(WizardView, { title: translate('wizard.success_title', { namespace }), description: translate('wizard.success_description', { namespace }), actions: actions, error: error, successMode: true },
        React.createElement("div", { className: "qmb-alert--info" },
            React.createElement("i", { className: "fa-light fa-lightbulb-on alert__visual" }),
            translate('wizard.sync_info', { namespace }))));
}
